var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RvbControls"},[_c('CategoryMenuFilter',{attrs:{"filter-config":_vm.filterConfig}}),_c('div',{staticClass:"RvbControls__search"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }